export const FilterSpecialCharacterFileName = (
  filename: string
): { isValid: boolean; message: string } => {
  const invalidChars = ["\\", "/", ":", "*", "?", '"', "<", ">", "|", "#", "'"];

  for (const char of invalidChars) {
    if (filename.includes(char)) {
      return {
        isValid: false,
        message: `Filename cannot contain special character ${char}`,
      };
    }
  }

  return {
    isValid: true,
    message: "",
  };
};

export const TrimFilename = (filename: string): string => {
  const lastDotIndex = filename.lastIndexOf(".");
  if (lastDotIndex === -1) {
    return filename.trim();
  }

  const name = filename.slice(0, Math.max(0, lastDotIndex));
  const extension = filename.slice(Math.max(0, lastDotIndex));

  return `${name.trim()}${extension}`;
};
